import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate, Router } from '@angular/router';
import { userService } from './userService';
import Swal from 'sweetalert2';

@Injectable()
export class authenticationService implements CanActivate {

    isAuthenicated: boolean;
    constructor(private router: Router, private userInfo: userService) {

    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {


        if (this.userInfo.isAuthenticatedUser()) {
            this.isAuthenicated = true;
        }
        else {
            Swal("Unauthorized Access!...");
            this.router.navigate(['/BeforeLogin/Login']);
        }

        return this.isAuthenicated;

    }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Services/authenticationService.ts